import { ApiHelper } from '../common/ApiHelper';

export default {
  buildAiEngineConfig(aiEngineConfig, modelType) {
    if (!aiEngineConfig && modelType === 'HostedModel') {
      const newAiEngineConfig = {
        inferenceOptions: null,
        predictEngineType: null,
        inputs: [],
        outcomes: [],
      };
      return newAiEngineConfig;
    }
    return aiEngineConfig;
  },

 

  async modelAliasFetcher(alias: string) {
    try {
      const { data } :any = await ApiHelper.GetModelViewUrlByAlias(alias);
      return { success: true, data: data };
    } catch (error) {
      console.error(error);
      return { success: false, data: undefined };
    }
  },

  validateAliasInputString(input : string) {
    // Regular expression to match lowercase letters, hyphens, and underscores
    const regex = /^[a-z0-9_-]+$/i;
  
    // Test if the input matches the regular expression
    return regex.test(input);
  }
};
